import { render, staticRenderFns } from "./_location-info.vue?vue&type=template&id=54406726&scoped=true&"
import script from "./_location-info.vue?vue&type=script&lang=js&"
export * from "./_location-info.vue?vue&type=script&lang=js&"
import style0 from "./_location-info.vue?vue&type=style&index=0&id=54406726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54406726",
  null
  
)

export default component.exports